// @ts-nocheck
import { AbstractRequestActionMessage } from "./AbstractRequestActionMessage";

export class RequestActionMessage extends AbstractRequestActionMessage {
  constructor() {
    super();
  }
}
